export default __webpack_public_path__ + "static/media/site-maps.ebc052ac.png";